(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    

  function progressoffers() {
    /* requires template: cart.compare.liquid */    
    fetch('/cart?view=compare')
    .then((resp) => resp.json())
    .then((cart) => {
      var quantity = 0;
      const subheads = document.querySelectorAll('.product-info .tieroffers .fourcol.is-deals .head');       
      // const subheads = document.querySelectorAll('.product-info .tieroffers .head');
      const progbar = document.querySelector('.product-info .tieroffers progress-bar');
      const heading = document.querySelector('.product-info .tieroffers h3');
      const container = document.querySelector('.product-info .tieroffers.midyear');
      
      if (!progbar) return;

      const stepsize = progbar.getAttribute('data-stepsize').slice(0, -1).split(',');
      const offers = progbar.getAttribute('data-offers').slice(0, -1).split('|');
    
      cart.items.forEach(item => {
        var qualified = true;
        
        if (item.compare_at_price > item.original_price) {
          qualified = false;
        } else {
          item.product_tags.forEach(tag => {
            if (tag.trim() == 'gift-card') qualified = false;
          });          
        }
        if (qualified) quantity += item.quantity;
      });

      var offer_qual = {};
      var offer_each = {};
      var offer_save = {};
      var key = null; 

      for (i = 0; i < offers.length; i++) {
        var bits = offers[i].split(';');

        offer_qual[i] = parseInt(bits[0]);
        offer_each[i] = bits[1];
        offer_save[i] = bits[2]; 
        
        if (quantity < offer_qual[i]) {
          subheads[i].classList.remove('done'); 
          if (key == null) {
            key = i;
          }
        } else {
          subheads[i].classList.add('done')
        }
      };  

      var pct = 0;
      var step = 0;
      for (q = 1; q <= quantity; q++) {
  
        if (q > offer_qual[step]) {
          step++;
        }
        pct += parseFloat(stepsize[step]);         
      }   

      if (offer_qual[key]) {
        const value = offer_each[key];
        const number = parseFloat(value.match(/\d+/)[0]);
        const total_saving = number * offer_qual[key];
        heading.innerHTML = 'Add <span>' + (parseInt(offer_qual[key]) - quantity) + ' more</span> and save $<span>' + total_saving + '</span>'; 
      } else {
        heading.innerHTML = '';
      }

      progbar.setAttribute('aria-valuenow', pct);
    });  
  }

  document.addEventListener('cart:change', function() {
    progressoffers();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-get-started"] && !window.DesignMode) return;
  try {
    
  const fullmodal = document.getElementById('fullmodal');
  const buynow = document.getElementById('buynow');
  const prodcount = document.querySelector('#prodcount strong');
  const minicart = document.getElementById('minicart');
  const choices = document.getElementById('choices');
  const progress = document.querySelector('#progress>progress');
  const styles = document.querySelectorAll('#fullmodal #styles li');
  const sizes = document.querySelector('#fullmodal #sizes>ul');
  const progressimg = document.querySelector('#progress>img'); 
  const anchor = document.querySelector('.cuspage>h1>strong');    
  const bubble = document.getElementById('bubble');
  const sections =  document.querySelectorAll('#fullmodal section');
  const nextbuttons = document.querySelectorAll('#fullmodal section .next');
  const cartadd = document.getElementById('cartadd');
  const modalback =  document.getElementById('modalback');
  const gbuttons = document.querySelectorAll('#gender>.button');
  const gfingers = document.querySelectorAll('#gender .finger');  
  const products =  document.querySelectorAll('#fullmodal .cat>a');
  const moveslide =  document.querySelectorAll('#productslide>.animated-arrow');
  var klaviyoshown = false;

  const countup = ['','first','second','third','fourth','fifth','sixth','seventh','eighth','next'];
  
  var itemcount = 0;
  var gender = "m";

  var pct = 10;

  function moveprogress(pct) {
    pct = parseInt(pct);
    sections[section].classList.add('show');
    progress.value = pct;
    progressimg.style.left = pct + '%';
  }

  function anchorbubble() {
    if (window.innerWidth > 1000) {    
      bubble.style.left = (anchor.offsetLeft + anchor.offsetWidth);
      bubble.style.top = anchor.offsetTop - 50;
    } else {
      bubble.style.left = 0;
      bubble.style.top = '.5rem';
    }
  }

  function clearsizes() {
    var match = false;
    var currsize = fullmodal.dataset.size;
    document.querySelectorAll('#fullmodal #sizes li>span').forEach(size => {

      var thissize = size.parentNode.dataset.size;
      
      if (thissize == currsize) {
        size.classList.remove('button--outline');
        match = true;
      } else {
        size.classList.add('button--outline');
      }
    });

    if (!match) {
      choices.disabled = true;
    } else {
      choices.disabled = false;
    }
  }

  function populatesizes(prodsizes) {

    var splitsizes = prodsizes.split(',');
    var currsize = fullmodal.dataset.size;
    var output = '';
    
    splitsizes.forEach(size => {
      var sizeparts = size.split('|');
      output += '<li data-size="' + sizeparts[0].toLowerCase() + '"><span class="button button--lg circle button--outline">' + sizeparts[0] + '</span><p class="cm">' + sizeparts[2] + '</p><p class="in">' + sizeparts[3] + '</p></li>';
    });
    
    sizes.innerHTML = output;
    clearsizes();
  }

  function updatecart() {
    fetch('/cart.js')
      .then((resp) => resp.json())
      .then((data) => {
  
        itemcount = Math.min(data.item_count + 1, countup.length - 1);
        prodcount.innerHTML = countup[itemcount];
  
        var htmlout = '<table>';

        if (data.items.length == 0) {
          htmlout += '<tr><td>Your cart is empty.</td></tr>';
          buynow.classList.add('hide');
        } else {
          buynow.classList.remove('hide');
        
          for (let i = 0; i < data.items.length; i++) {
          
            htmlout += '<tr>';
    
            var vtitle = data.items[i].variant_title.split(' / ');
            if (vtitle.length == 2) title = data.items[i].product_title + ' - ' + vtitle[1];
            else title = data.items[i].product_title + ' - ' + vtitle;
            
            var image = '<img src="' +  data.items[i].image + '&width=40" alt="' + title + '">';         
            htmlout += '<td>';
            htmlout += image;
            htmlout += '</td>';
    
            var quantity = data.items[i].quantity;
    
            htmlout += '<td>';
            htmlout += quantity + 'x';
            htmlout += '</td>';             
    
            htmlout += '<td>';
            htmlout += title;
            htmlout += '</td>';
    
            htmlout += '<td>';
            htmlout += '<button data-id="' + data.items[i].id + '">✖</button>';
            htmlout += '</td>';
    
            const price = (data.items[i].price * quantity).toString();
            const formatted = shopcurrency + price.slice(0, -2) + '.' + price.slice(-2);             
    
            /*
            htmlout += '<td>';
            htmlout += formatted;
            htmlout += '</td>';
            */
    
            htmlout += '</tr>';
          }
        }
        htmlout += '</table>';
        minicart.innerHTML = htmlout;

      
      });
  }

  function advance() {

    console.log('section',section);

    sections[section].classList.remove('show');
    if (section == firstsection) modalback.classList.remove('hide');
    
    if (section == sections.length - 1) {
      cartadd.disabled = true;
      section = 1;
    }

    if (section == 2) {
        if (klaviyoshown) {
        section++;
      } else {
          klaviyoshown = true;
      }
    }
    
    section++;
    sections[section].classList.add('show');
    moveprogress(sections[section].dataset.progress);

    for (let i = 0; i < products.length; i++) {
      products[i].classList.remove('selected');
    }

    if (section == 1) {
      var gender = fullmodal.dataset.gender;
      if (gender == 'm') var fullgender = 'mens';
      else var fullgender = 'womens';
      var firstprod = document.querySelector('#styles .' + fullgender + ' li');
      firstprod.classList.add('active');
      populatesizes(firstprod.dataset.sizes);
    }

    if (section > 1) {
      fullmodal.classList.remove('whiteclose');
    }

    if (fullmodal.dataset.addproduct != '') {
      var pid = parseInt(fullmodal.dataset.addproduct);
      fullmodal.dataset.addproduct = '';
  
      var productdata = {
        'id':pid,
        'quantity':1
      };
      
      fetch('/cart/add.js', {
        body: JSON.stringify(productdata),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
        }).then(function(response) {
        return response.json();
      }).then(function(json) {
        updatecart();
      }).catch(function(err) {
      });
    }    
  }

  window.addEventListener('klaviyoForms', function(e) { 
    if (e.detail.type == 'submit') advance();
  });

  populatesizes(prodsizes);
  anchorbubble();
  addEventListener("resize", (event) => anchorbubble());  

  for (let i = 0; i < moveslide.length; i++) {
    moveslide[i].addEventListener('click', function() {
      if (!activecat) {
        var selector = '#productslide .' + fullmodal.dataset.collection;        
        var activecat = document.querySelector(selector);
        activecat.classList.add('smooth');
        if (activecat.clientWidth == activecat.scrollWidth) {
          /*
          console.log('no scroll');
          console.log('swi',activecat.clientWidth,activecat.scrollWidth);
          */
        }
        
      }
      if (this.classList.contains('nextslide')) var xmove = 576;
      else var xmove = -576;
      activecat.scrollLeft += xmove;      
    });
  }

  let startX;
  let scrollLeft;
  let isDown;
  
  var selector = '#productslide .' + fullmodal.dataset.collection;        
  var activecat = document.querySelector(selector);  
  
  activecat.addEventListener('mousedown',e => mouseIsDown(e));  
  activecat.addEventListener('mouseup',e => mouseUp(e))
  activecat.addEventListener('mouseleave',e=>mouseLeave(e));
  activecat.addEventListener('mousemove',e=>mouseMove(e));
  
  function mouseIsDown(e){
    isDown = true;
    startX = e.pageX - activecat.offsetLeft;
    scrollLeft = activecat.scrollLeft;
    activecat.classList.remove('smooth');
  }
  function mouseUp(e){
    isDown = false;
  }
  function mouseLeave(e){
    isDown = false;
  }
  function mouseMove(e){
    if(isDown){
      e.preventDefault();
  
      const x = e.pageX - activecat.offsetLeft;
      const walkX = x - startX;
      activecat.scrollLeft = scrollLeft - walkX;
    }
  }

  for (let i = 0; i < gbuttons.length; i++) {
    gbuttons[i].addEventListener('click', function() {       
      gender = this.dataset.gender;

      fullmodal.setAttribute('data-gender', gender);
      fullmodal.setAttribute('data-style', this.dataset.collection);
      fullmodal.setAttribute('data-collection', this.dataset.collection);
      for (let ii = 0; ii < gbuttons.length; ii++) {
        if (gbuttons[ii].dataset.gender === gender) gbuttons[ii].classList.remove('button--outline');
        else gbuttons[ii].classList.add('button--outline');
      }
    });
  }

  for (let i = 0; i < nextbuttons.length; i++) {
    nextbuttons[i].addEventListener('click', function() {
      advance();
    });
  }

  for (let i = 0; i < styles.length; i++) {
    styles[i].addEventListener('click', function() {

      for (let i = 0; i < styles.length; i++) {
        styles[i].classList.remove('active');
      }
      this.classList.add('active');
      fullmodal.setAttribute('data-style', this.dataset.style);

      var prodsizes = this.dataset.sizes;
      populatesizes(prodsizes);

      fullmodal.setAttribute('data-collection', this.dataset.collection);
    });
  }

  var activesize = null;
  sizes.addEventListener('click', el => {
    if (activesize) activesize.classList.add('button--outline');
    activesize = el.target.closest('span');
    activesize.classList.remove('button--outline');     
    fullmodal.setAttribute('data-size', activesize.parentNode.dataset.size);
    clearsizes();
  });

  minicart.addEventListener('click', el => {
    var productx = el.target.closest('button');
    var pid = productx.dataset.id;

    var body = JSON.stringify({"quantity": 0,"id": pid});
  
    fetch('/cart/change.js', {
      body: body,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
      })
      .then((resp) => resp.json())
      .then((data) => {
        updatecart();
      });
  });

  for (let i = 0; i < products.length; i++) {
  
    products[i].addEventListener('click', function() {
      var size = 'size-' + fullmodal.dataset.size;
      var classes = this.classList
      var variants = this.dataset.variants.split(',');   

      for (let i = 0; i < products.length; i++) {
        products[i].classList.remove('selected');
      }

      this.classList.add('selected');

      cartadd.disabled = false;

      for (let i = 0; i < classes.length; i++) {
        if (classes[i] == size) {
          var pid = variants[i];
          fullmodal.dataset.addproduct = pid;        
          break;
        }
      }   
    });
  }  

  document.querySelector('#fullmodal .metric input').addEventListener('change', function() {
    fullmodal.setAttribute('data-metric', this.checked);
  });

  fullmodal.classList.add('whiteclose');  

  modalback.addEventListener('click', function() {

    if (section == (firstsection + 1)) {
      modalback.classList.add('hide'); 
    }
    
    if (section > firstsection) {
      sections[section].classList.remove('show');
      section--;

      if (section == 3 && klaviyoshown) section--;
      
      moveprogress(sections[section].dataset.progress);
    }
  }); 
  

  } catch(e) { console.error(e); }
})();
})();
